import ConfigService from "../services/ConfigService";
import LocalStorageService from "../services/LocalStorageService";
import CoreService from "../services/CoreService";
//import IdentityService from "../services/IdentityService";

//import ServiceResponse from "../models/ServiceResponse";

//import DataTransformManager from "./DataTransformManager";





export default class DataApiManager
{

    constructor(){
        this.configService = new ConfigService();
        this.LocalStorageService = new LocalStorageService();
        this.coreService = new CoreService();
    }





}


